
import {Component, Prop, Vue} from 'vue-property-decorator';
import RulesUtil from "@/util/rules";
import ContratoService from "@/service/contrato.service";
import Listas from "@/models/lists/listas.model";
import ContratoModel from "@/models/contratos/contrato.model";
import {namespace} from "vuex-class";

const contratoStore = namespace('contrato');

@Component({
  name: "dados-contrato-component"
})
export default class DadosContratoComponent extends Vue {

  @Prop({type: Object, default: new ContratoModel()})
  public contrato!: ContratoModel;

  @Prop({type: Number})
  public step!: number;

  private rules = RulesUtil;
  private listas = new Listas();

  async saveUpdateDados() {
    if ((this.$refs.formDados as HTMLFormElement).validate()) {
      let retorno: ContratoModel;
      if (this.contrato.id) {
        retorno = await ContratoService.atualizar(this.contrato);
      } else {
        retorno = await ContratoService.cadastrar(this.contrato);
      }
      this.$emit("retornoContrato", retorno);
    }
  }

}
